/**
 * @module AccountsPreferenceConstants
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

/**
 * @const AccountsPreferenceConstants
 */
export default keyMirror({
  // Account Reorder Constants
  REORDER_BACKPAGE_REFERENCE: null,
  REQUEST_ACCOUNT_REORDER: null,
  SET_ACCOUNT_REORDER: null,
  ACCOUNT_REORDER_BATCH_CALL: null,

  // Preference Constants
  STATEMENT_BACKPAGE_REFERENCE: null,
  REQUEST_STATEMENT_PREFERENCES: null,
  REQUEST_STATEMENT_PREFERENCES_SUCCESS: null,
  SET_STATEMENT_PREFERENCES: null,
  REQUEST_STATEMENT_PREFERENCES_ERROR: null,

  // Rename Account constants
  RENAME_BACKPAGE_REFERENCE: null,
  UPDATE_SELECTED_ACCOUNT_ID: null,
  UPDATE_ACCOUNT_NAME: null,
  UPDATE_ACCOUNT_NAME_SUCCESS: null,
  UPDATE_ACCOUNT_NAME_FAIL: null,
});
